(function () {
    'use strict';

    angular.module('app').controller('BriefEditController', BriefEditController);

    function BriefEditController(
        $scope,
        $timeout,
        $rootScope,
        $filter,
        $state,
        $stateParams,
        LinePlanService,
        ImageUrl,
        BriefService,
        UserService,
        StatusService,
        ImageService,
        UploadedImageUrl,
        ImageNotAvailableName,
        DefaultThumbnailSize,
        DefaultEnlargeSize,
        toaster,
        cfpLoadingBar,
        $location,
        ux
    ) {
        var model = this;
        $scope.briefSeasonalId = $stateParams.briefSeasonalId;
        $scope.currentUser = $rootScope.globals.currentUser;
        $scope.userId = $rootScope.userId;

        $scope.userPermissionFlag = $rootScope.userPermissions;
        $scope.currentUploadedImageUrl = UploadedImageUrl;
        $scope.currentDefaultThumbnailSize = DefaultThumbnailSize;
        $scope.currentDefaultEnlargeSize = DefaultEnlargeSize;
        $scope.currentImageNotAvailableName = ImageNotAvailableName;
        $scope.currentUserId = $rootScope.userId;
        $scope.urlId = $location.search().profile;

        $scope.permissionDenied = function () {

            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }
        model.briefSeasonalId = $stateParams.briefSeasonalId;
        model.isReadOnly = true;

        model.BriefRead = '';
        model.BriefCreate = '';
        model.BriefEdit = '';
        model.BriefStatusChange = '';
        model.BriefRRAssignment = '';
        model.BriefPatternCount = 0;

        model.ImageUrl = ImageUrl;

        model.image = null;
        model.imageFileName = '';
        model.validImageExtensions = ['jpg', 'jpeg', 'gif', 'png'];
        model.filesUploaded = 0;
        model.inValidFiles = 0;

        model.failedFiles = '';
        model.relinkIssuesList = [];

        model.imageInterface = {};
        model.uploadCount = 0;
        model.success = false;
        model.error = false;

        // Listen for when the interface has been configured.
        $scope.$on('$dropletReady', function () {
            model.imageInterface.allowedExtensions(['png', 'jpg', 'bmp', 'gif']);
            model.imageInterface.defineHTTPSuccess([/2.{2}/]);
            model.imageInterface.useArray(true);
        });

        /*End drag and drop function section*/

        $scope.status = {
            open: true,
            isFirstOpen: true,
            isFirstDisabled: false
        };

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            //brief permissions
            if (userPermissionRow[0] == 3) {
                if (userPermissionRow[1] == 1) {
                    model.BriefRead = true;
                }
                if (userPermissionRow[1] == 2) {
                    model.BriefEdit = true;
                    $scope.editMode = true;
                }
                if (userPermissionRow[1] == 3) {
                    model.BriefCreate = true;
                }
                if (userPermissionRow[1] == 4) {
                    model.BriefStatusChange = true;
                }
                if (userPermissionRow[1] == 5) {
                    model.BriefRRAssignment = true;
                }
                if (userPermissionRow[1] == 7) {
                    model.BriefDelete = true;
                }
            }

            //pattern permissions
            if (userPermissionRow[0] == 4) {
                if (userPermissionRow[1] == 3) {
                    model.PatternCreate = true;
                }
            }
        });

        if (!model.BriefRead && !model.BriefEdit) {
            $state.go('permissionDenied');
        }

        //StatusService.isRecordDeleted(2, model.briefSeasonalId).then(
        //    function (response) {
        //        if (response == true) {
        //            toaster.pop({
        //                type: 'note',
        //                title: 'Brief Deleted',
        //                body: 'The Brief you are trying to access is deleted.',
        //                timeout: 5000
        //            });
        //            $state.go('Search');
        //        }
        //    },
        //    function (error, status) {
        //        toaster.pop({
        //            type: 'error',
        //            title: 'Error',
        //            body: 'Please contact your System Administrator.',
        //            timeout: 5000
        //        });
        //        $state.go('Search');
        //    }
        //);

        function getBrandPermissions(brandId) {
            //brand permissions
            if (!$rootScope.brandPermissions)
                return;
            var idx = $rootScope.brandPermissions.map(function (e) { return e.BrandId }).indexOf(brandId);
            if (!$rootScope.brandPermissions[idx].IsAssigned) {
                $state.go('permissionDenied');
                return;
            }
        }

        function setEditPageDetail(editPageDetail) {
            // set lists from detail response
            model.statusList = editPageDetail.statusList;
            model.groupList = editPageDetail.groupList;
            model.users = editPageDetail.users;
            model.seasons = editPageDetail.seasons;
            model.briefSeasons = editPageDetail.briefSeasons;

            // set main brief data from response
            model.briefDetails = editPageDetail.briefDetails;
            
            model.briefDetails.BriefStartDate = $filter('date')(model.briefDetails.BriefStartDate, 'MM/dd/yyyy', '+0000');
            model.briefDetails.BriefEndDate = $filter('date')(model.briefDetails.BriefEndDate, 'MM/dd/yyyy', '+0000');
            model.briefDetails.BriefActualCompletionDate = $filter('date')(model.briefDetails.BriefActualCompletionDate, 'MM/dd/yyyy', '+0000');

            // set flags
            model.briefCurrStatusId = model.briefDetails.StatusId;
            model.isReadOnly = editPageDetail.isReadOnly;
            model.activePatternsOrPrototypesExist = editPageDetail.activePatternsOrPrototypesExist;

            model.sapBrandId = model.briefDetails.SAPBrandId;

            model.briefImage = editPageDetail.briefImage;
            model.briefImageFull = editPageDetail.briefImageFull;
            model.uploadedImage = editPageDetail.uploadedImage;

            model.image1 = model.briefDetails.ImageName != ImageNotAvailableName;
        }

        function getBriefPatternCount() {
            BriefService.getBriefPatternsCount(
                model.briefSeasonalId
            ).then(function (response) {
                model.BriefPatternCount = response;
            });
        }

        //function loadBriefEditDetails(briefSeasonalId) {
        //    BriefService.getBriefEditDetails(briefSeasonalId).then(function (editPageDetail) {
        //        //if (editPageDetail === null) {
        //        //    $state.go('permissionDenied');
        //        //    return;
        //        //}
        //        getBrandPermissions(editPageDetail.briefDetails.BrandId);
        //        setEditPageDetail(editPageDetail);
        //        getBriefPatternCount(briefSeasonalId);
        //    });

        //    var lastUsedModel = {
        //        UserId: $rootScope.userId,
        //        ProjectId: model.briefSeasonalId,
        //        ProjectLevelId: 2
        //    };

        //    UserService.logLastUseProject(lastUsedModel);
        //}

        /**
         * Fetches all the option list values that are the same for every brief and do not vary by Status, Brand, etc...
         */
        function loadListOptions() {
            BriefService.getBriefEditLists().then(function (response) {
                model.briefTypesList = response.briefTypesList;
                model.consumerSegmentationList = response.consumerSegmentationList;
                model.packagingList = response.packagingList;
                model.productPositioningList = response.productPositioningList;
            });
        }

        //function initEditPage() {
        //    loadListOptions();
        //    loadBriefEditDetails(model.briefSeasonalId);
        //}

        model.getUser = function ($model) {
            if ($scope.briefEditForm.$dirty) {
                if (!$model) {
                    var nameCheck = false;
                    $scope.getUserResponse = false;
                    angular.forEach(model.users, function (k) {
                        var name = model.briefDetails.ResponsibleName.FullName
                            ? model.briefDetails.ResponsibleName.FullName.toLowerCase()
                            : model.briefDetails.ResponsibleName.toLowerCase();
                        if (name == k.FullName.toLowerCase() && !nameCheck) {
                            $scope.getUserResponse = true;
                            model.briefDetails.ResponsibleId = k.Id;
                            model.briefDetails.ResponsibleName = k.FullName; //assign name
                            nameCheck = true;
                        }
                    });
                } else {
                    $scope.getUserModel = $model;
                    //assign responsible id
                    model.briefDetails.ResponsibleId = $scope.getUserModel.Id;
                    $scope.getUserResponse = true;
                }
                model.validateUser();
            }
        };

        model.validateUser = function () {
            $timeout(function () {
                if ($scope.getUserResponse) {
                    $scope.briefEditForm.rrAssignment.$setValidity('responsibleName', true);
                } else {
                    $scope.briefEditForm.rrAssignment.$setValidity('responsibleName', false);
                }
            }, 100);
        };

        model.checkBriefName = function (scope) {
            toaster.clear();

            BriefService.isBriefNameExists(
                model.briefDetails.BriefId,
                model.briefDetails.BriefName,
                model.briefDetails.BrandId,
                model.briefDetails.SeasonId
            ).then(function (response) {
                if (response) {
                    toaster.pop({
                        type: 'note',
                        title: 'Name duplication',
                        body: 'You may continue, but please note this name already exists.',
                        timeout: 5000
                    });
                }
            });
        };

        //Check if pattern or protos exist for Brief for statuses Cancelled and Locked
        model.checkPatternProtoStatus = function () {
            $scope.briefEditForm.$setValidity('briefStatusCheck', true);

            if (model.activePatternsOrPrototypesExist) {
                if (model.briefDetails.StatusId == 4 || model.briefDetails.StatusId == 5 || model.briefDetails.StatusId == 7) {
                    $scope.briefEditForm.$setValidity('briefStatusCheck', false);
                }
            }
        };

        model.View = function () {
            $state.go('briefView', { briefSeasonalId: model.briefSeasonalId });
        };

        model.Copy = function () {
            $state.go('briefCopy', { parentBriefSeasonalId: model.briefSeasonalId });
        };

        model.CreatePattern = function () {
            if(model.canCreatePattern())
                $state.go('projectCreate', { briefSeasonalId: model.briefSeasonalId });
        };

        model.canCreatePattern = function() {
            return model.PatternCreate && (model.briefCurrStatusId === 2 || model.briefCurrStatusId === 3);
        };

        model.RelinkClicked = function () {
            model.relinkIssuesList = [];
            if (model.BriefPatternCount > 0) {
                model.relinkIssuesList.push({ IssueText: 'The brief cannot have any linked patterns' });
            }
        };

        model.Do_Relink = function () {
            BriefService.relinkBrief(model.briefDetails.BriefId, model.linePlanId).then(function (response) {
                if (response.IsSuccessful) {
                    $state.reload();
                    toaster.pop({
                        type: 'success',
                        title: 'Success!',
                        body: 'Relink succeeded.',
                        timeout: 5000
                    });
                } else {
                    toaster.pop({
                        type: 'error',
                        title: 'Error',
                        body: 'Re-link failed. ' + response.Message,
                        timeout: 5000
                    });
                }
            });
        };

        model.globalLaunch = function (t) {
            model.briefDetails.isAspacRegion = t;
            model.briefDetails.isCanadaRegion = t;
            model.briefDetails.isEmea3pRegion = t;
            model.briefDetails.isEmeaDistRegion = t;
            model.briefDetails.isSamerRegion = t;
            model.briefDetails.isEmeaOwnedRegion = t;
            model.briefDetails.isUSARegion = t;
        };

        function formatString(format) {
            var day = parseInt(format.substring(3, 5));
            var month = parseInt(format.substring(0, 2));
            var year = parseInt(format.substring(6, 10));
            var date = new Date(year, month - 1, day);
            return date;
        }

        //Validate Brief Date
        model.validateBriefDate = function (scope, dateField) {
            scope.briefEditForm.briefStartDate.$setValidity('startDate', true);
            scope.briefEditForm.briefEndDate.$setValidity('endDate', true);

            var currentStartDate = $filter('date')(model.briefDetails.BriefStartDate, 'MM/dd/yyyy');
            var currentEndDate = $filter('date')(model.briefDetails.BriefEndDate, 'MM/dd/yyyy');

            if (currentStartDate && currentEndDate) {
                var date2 = new Date(formatString(currentEndDate));
                var date1 = new Date(formatString(currentStartDate));

                if (date2.getTime() - date1.getTime() >= 0) {
                    scope.briefEditForm.briefStartDate.$setValidity('startDate', true);
                    scope.briefEditForm.briefEndDate.$setValidity('endDate', true);
                } else {
                    if (dateField == 's') {
                        scope.briefEditForm.briefStartDate.$setValidity('startDate', false);
                    } else if (dateField == 'e') {
                        scope.briefEditForm.briefEndDate.$setValidity('endDate', false);
                    }
                }
            }
        };

        model.setLinePlan = function (selectedLinePlanId, linePlanStatusId) {
            if (linePlanStatusId == 2 || linePlanStatusId == 3) {
                model.linePlanId = selectedLinePlanId;
                model.radioValue = model.linePlanId;
            }
        };

        model.loadLinePlans = function () {
            LinePlanService.getLinePlansByBrandSeason(
                model.briefDetails.BrandId,
                model.selectedNewBriefSeason.SeasonId,
                0
            ).then(function (response) {
                if (response) {
                    model.linePlansForRelink = response;
                    model.linePlanForRelinkCount = model.linePlansForRelink.length;
                } else {
                    model.linePlanForRelinkCount = 0;
                }
            });
        };

        //validate specicial packaging

        model.checkSpecialPackage = function (fieldVal) {
            $scope.briefEditForm.$setValidity('packageIdInvalid', true);
            $scope.briefEditForm.$setValidity('packageDescInvalid', true);

            if (model.briefDetails.PackagingId == 5) {
                if (!model.briefDetails.SpecialPackag || model.briefDetails.SpecialPackag.trim() === '' || model.briefDetails.SpecialPackag === null) {
                    if (fieldVal == 1) {
                        $scope.briefEditForm.$setValidity('packageIdInvalid', false);
                    }
                    if (fieldVal == 2) {
                        $scope.briefEditForm.$setValidity('packageDescInvalid', false);
                        model.briefDetails.SpecialPackag = '';
                    }
                }
            }
        };

        //Save Brief Header and Details
        model.Save = function (isFormInvalid) {
            if (model.needToValidate) {
                model.SaveAfter = true;
                return;
            }

            model.SaveAfter = false;

            if (isFormInvalid) {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'Please review all fields indicated in red',
                    timeout: 5000
                });
                return;
            }

            $scope.briefEditForm.$setPristine();

            var accountableId = model.briefDetails.ResponsibleId;

            if (model.BriefRRAssignment) {
                if (model.briefDetails.ResponsibleName.Id) {
                    accountableId = model.briefDetails.ResponsibleName.Id;
                }
            }

            if (!accountableId) {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'User Id is missing.',
                    timeout: 5000
                });
                return;
            }

            var briefStartDate = '';
            var briefEndDate = '';
            var estCompleteDate = '';
            var actCompleteDate = '';

            if (model.briefDetails.BriefStartDate) {
                //briefStartDate = $filter('date')(model.briefDetails.BriefStartDate, 'short');
            }

            if (model.briefDetails.BriefEndDate) {
                //briefEndDate = $filter('date')(model.briefDetails.BriefEndDate, 'short');
            }

            if (model.briefDetails.BriefEstimatedCompletionDate) {
                estCompleteDate = $filter('date')(model.briefDetails.BriefEstimatedCompletionDate, 'short');
            }

            if (model.briefDetails.BriefActualCompletionDate) {
                actCompleteDate = $filter('date')(model.briefDetails.BriefActualCompletionDate, 'short');
            }

            console.log(model.briefDetails.BriefStartDate);

            var updateModel = {
                BriefSeasonalId: model.briefSeasonalId,
                BriefId: model.briefDetails.BriefId,
                BriefName: model.briefDetails.BriefName,
                ResponsibleId: accountableId,
                StatusId: model.briefDetails.StatusId,
                IsLocked: model.briefDetails.IsLocked,
                StartDate: model.briefDetails.BriefStartDate,
                EndDate: model.briefDetails.BriefEndDate,
                EstimatedCompletionDate: estCompleteDate,
                ActualCompletionDate: actCompleteDate,
                TargNumPat: model.briefDetails.TargetNumberPatterns,
                TargNumCol: model.briefDetails.TargetNumberColors,
                BriefTypeId: model.briefDetails.BriefTypeId,
                ConsumerSegmentationId: model.briefDetails.ConsumerSegmentationId,
                PackagingId: model.briefDetails.PackagingId,
                ProductPositioningId: model.briefDetails.ProductPositioningId,
                PossFactKey1: model.briefDetails.FactoryKey1,
                PossFactNm1: model.briefDetails.PossFactNm1,
                PossCtrName1: model.briefDetails.PossCtrName1,
                PossFactKey2: model.briefDetails.FactoryKey2,
                PossFactNm2: model.briefDetails.PossFactNm2,
                PossCtrName2: model.briefDetails.PossCtrName2,
                PossFactKey3: model.briefDetails.FactoryKey3,
                PossFactNm3: model.briefDetails.PossFactNm3,
                PossCtrName3: model.briefDetails.PossCtrName3,
                FactoryGroupKey1: model.briefDetails.FactoryGroupKey1,
                FactoryGroupName1: model.briefDetails.FactoryGroupName1, 
                FactoryGroupKey2: model.briefDetails.FactoryGroupKey2,
                FactoryGroupName2: model.briefDetails.FactoryGroupName2,
                FactoryGroupKey3: model.briefDetails.FactoryGroupKey3,
                FactoryGroupName3: model.briefDetails.FactoryGroupName3,
                RetChanKey1: model.briefDetails.RetailChannelKey1,
                RetChan1: model.briefDetails.RetailChannel1,
                RetChanKey2: model.briefDetails.RetailChannelKey2,
                RetChan2: model.briefDetails.RetailChannel2,
                RetChanKey3: model.briefDetails.RetailChannelKey3,
                RetChan3: model.briefDetails.RetailChannel3,
                RetChanKey4: model.briefDetails.RetailChannelKey4,
                RetChan4: model.briefDetails.RetailChannel4,
                RetChanKey5: model.briefDetails.RetailChannelKey5,
                RetChan5: model.briefDetails.RetailChannel5,
                ProjectedQty: model.briefDetails.ProjectedQuantity,
                SeqOrder: model.briefDetails.OrderSequence,
                IsCarryOverBrief: model.briefDetails.IsCarryOverBrief,
                IsGlobalLaunch: model.briefDetails.isGlobalLaunch,
                UsaRegion: model.briefDetails.isUSARegion,
                EmeaOwnedRegion: model.briefDetails.isEmeaOwnedRegion,
                CanRegion: model.briefDetails.isCanadaRegion,
                SamerRegion: model.briefDetails.isSamerRegion,
                AspacRegion: model.briefDetails.isAspacRegion,
                Emea3pRegion: model.briefDetails.isEmea3pRegion,
                EmeaDistRegion: model.briefDetails.isEmeaDistRegion,
                FldTest: model.briefDetails.isFieldTesting,
                NewHeelYn: model.briefDetails.isNewHeel,
                FobMin: model.briefDetails.MinimumFOB,
                FobMax: model.briefDetails.MaximumFOB,
                CompetBrand1: model.briefDetails.CompetitiveBrand1,
                CompetBrand2: model.briefDetails.CompetitiveBrand2,
                CompetProd1: model.briefDetails.CompetitiveProduct1,
                CompetProd2: model.briefDetails.CompetitiveProduct2,
                RetailPrice1: model.briefDetails.RetailPrice1,
                RetailPrice2: model.briefDetails.RetailPrice2,
                Trends: model.briefDetails.Trends,
                SpecPackag: model.briefDetails.SpecialPackag,
                ProjectMin: model.briefDetails.ProjectMinimum,
                ConsumerFlds: model.briefDetails.ConsumerFields,
                MktgConsDes: model.briefDetails.MarketingConsumerDescription,
                GeneralNotes: model.briefDetails.GeneralNotes,
                WFGroupId: model.briefDetails.WFGroupId
            };

            BriefService.updateBrief(updateModel)
                .then(function (editPageDetail) {
                    setEditPageDetail(editPageDetail);
                    ux.reportSuccess('Record Saved Successfully.');
                })
                .catch(function (error) {
                    ux.reportError(error, 'There was an error while saving the record. Please contact system administrator.');
                })
                .finally(function () {
                    $scope.briefEditForm.$setPristine();
                    $scope.briefEditForm.$setUntouched();
                });
        };

        model.deleteBrief = function () {
            BriefService.deleteBriefSeasonal(model.briefSeasonalId).then(
                function () {
                    toaster.pop({
                        type: 'success',
                        title: 'Success!',
                        body: 'Record Deleted Successfully.',
                        timeout: 5000
                    });
                    $state.go('Search');
                },
                function () {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error while deleting the record. Please contact your administrator.',
                        timeout: 5000
                    });
                }
            );
        };

        model.factoryGroupNameAndKey = function (whichFactory) {

            var f = "";
            if (model.briefDetails) {
                switch (whichFactory) {
                    case 1:
                        f = model.briefDetails.FactoryGroupName1;
                        if (model.briefDetails.FactoryGroupKey1 && model.briefDetails.FactoryGroupKey1.length > 0) {
                            f += " (" + model.briefDetails.FactoryGroupKey1 + ")";
                        }
                        break;
                    case 2:
                        f = model.briefDetails.FactoryGroupName2;
                        if (model.briefDetails.FactoryGroupKey2 && model.briefDetails.FactoryGroupKey2.length > 0) {
                            f += " (" + model.briefDetails.FactoryGroupKey2 + ")";
                        }
                        break;
                    case 3:
                        f = model.briefDetails.FactoryGroupName3;
                        if (model.briefDetails.FactoryGroupKey3 && model.briefDetails.FactoryGroupKey3.length > 0) {
                            f += " (" + model.briefDetails.FactoryGroupKey3 + ")";
                        }
                        break;
                    default:
                }
            }

            return f;
        };

        /*Start of Upload Image Section*/
        function clearImageUpload() {
            model.imageInterface = {};
            document.getElementById('file').value = null;
        }

        //Browse Image and Upload
        $scope.selectImage = function (e) {
            uploadImage(e.files[0], 'browse');
        };

        //Drag and Drop image and upload
        model.addImage = function (file) {
            uploadImage(file.file, 'dragdrop');
        };

        //Upload Image
        function uploadImage(file, source) {
            model.isImageError = '';
            model.isImageUploadSuccess = '';
            $scope.briefEditForm.$setDirty();

            model.file = file;

            var ext = model.file.name.substr(model.file.name.lastIndexOf('.') + 1).toLowerCase();
            var errors = 0;
            if (model.validImageExtensions.indexOf(ext) == -1) {
                errors++;
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'Invalid File Format',
                    timeout: 5000
                });
            }

            if (file.name.length > 175) {
                errors++;
                var a = file.files[0].name.length - 175;
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body:
                        'File name is ' + a + ' characters over the maximum amount of 175. Please rename your file, and try again.',
                    timeout: 5000
                });
                //remove file from droplet
                clearImageUpload();
            }

            if (errors == 0) {
                model.briefImage = '';
                var i = 0;
                angular.forEach(model.imageInterface.getFiles(model.imageInterface.FILE_TYPES.VALID), function (irow) {
                    if (model.imageInterface.getFiles(model.imageInterface.FILE_TYPES.VALID).length > 1) {
                        if (i < model.imageInterface.getFiles(model.imageInterface.FILE_TYPES.VALID).length) {
                            irow.deleteFile();
                        }
                    }
                    i++;
                });

                //setup image meta data object
                var imageMeta = {
                    ProjectId: model.briefDetails.BriefId,
                    ProjectLevel: 2,
                    ImageType: 1
                };

                ImageService.uploadImage(model.file, imageMeta).then(
                    function (response) {
                        //remove file from droplet
                        angular.forEach(model.imageInterface.getFiles(model.imageInterface.FILE_TYPES.VALID), function (irow) {
                            irow.deleteFile();
                        });

                        //set image
                        response.ImageName == ImageNotAvailableName ? (model.image1 = false) : (model.image1 = true);
                        model.uploadedImage = UploadedImageUrl + response.ImagePath + response.ImageName;
                        model.briefImage =
                            ImageUrl +
                            '?projectId=' +
                            model.briefDetails.BriefId +
                            '&projectLevel=2' +
                            '&imageType=1' +
                            '&size=' +
                            DefaultThumbnailSize +
                            '&t=' +
                            $filter('date')(new Date(), 'MMddyyHHmmss');

                        model.briefImageFull =
                            ImageUrl +
                            '?projectId=' +
                            model.briefDetails.BriefId +
                            '&projectLevel=2' +
                            '&imageType=1' +
                            '&size=' +
                            DefaultEnlargeSize +
                            '&t=' +
                            $filter('date')(new Date(), 'MMddyyHHmmss');

                        toaster.pop({
                            type: 'success',
                            title: 'Success!',
                            body: 'Image Uploaded Successfully',
                            timeout: 5000
                        });
                        clearImageUpload();
                    },
                    function (error, status) {
                        model.briefImage = ImageUrl + model.briefDetails.ImageName;
                        toaster.pop({
                            type: 'error',
                            title: 'Error!',
                            body:
                                'There was an error while uploading the image. Please contact system administrator. Error Message: ' +
                                error.ExceptionMessage,
                            timeout: 5000
                        });
                        clearImageUpload();
                    }
                );
            } else {
                clearImageUpload();
            }

            $scope.briefEditForm.$setPristine();
            $scope.briefEditForm.$setUntouched();
        }

        model.deleteImage = function (projectId, projectLevel, imageType) {
            ImageService.deleteImage(model.briefDetails.BriefId, projectLevel, imageType).then(
                function (response) {
                    toaster.pop({
                        type: 'success',
                        title: 'Success!',
                        body: 'Image Deleted Successfully',
                        timeout: 5000
                    });

                    //clear the image
                    model.image1 = false;

                    var date = new Date();
                    var t = date.getTime();
                    model.timeStamp = t;

                    //reset current image
                    model.uploadedImage = UploadedImageUrl + ImageNotAvailableName;

                    //reset set thumbnail image
                    model.briefImage =
                        ImageUrl +
                        '?projectId=' +
                        model.briefDetails.BriefId +
                        '&projectLevel=2' +
                        '&imageType=1' +
                        '&size=' +
                        DefaultThumbnailSize +
                        '&t=' +
                        $filter('date')(new Date(), 'MMddyyHHmmss');

                    //reset set enlarged thumbnail image
                    model.briefImageFull =
                        ImageUrl +
                        '?projectId=' +
                        model.briefDetails.BriefId +
                        '&projectLevel=2' +
                        '&imageType=1' +
                        '&size=' +
                        DefaultEnlargeSize +
                        '&t=' +
                        $filter('date')(new Date(), 'MMddyyHHmmss');
                },
                function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error while deleting the image. Please contact system administrator.',
                        timeout: 5000
                    });
                }
            );
        };

        model.closeModal = function () {
            $('#seasonList').modal('hide');
        };

        //initEditPage();
    }
})();
